/**
 * AreaPickerModal – area selection popup. Uses ListPickerModal for consistent styling.
 */
import React from 'react';
import { ListPickerModal, type ListPickerItem } from './ListPickerModal';
import { getAreaBilingualLabel, useTranslation } from '../../shared/i18n';

export interface AreaPickerModalProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (area: any) => void;
  areas: any[];
  selectedAreaId?: number | string;
}

function toPickerItem(area: any): ListPickerItem {
  const o = area as Record<string, unknown>;
  const label = getAreaBilingualLabel(o) || (typeof area.title === 'string' ? area.title : '') || (typeof area.name === 'string' ? area.name : '') || String(area.id);
  return { id: area.id, label, ...area };
}

function getAreaLabel(item: ListPickerItem): string {
  return getAreaBilingualLabel(item as Record<string, unknown>) || item.label || '';
}

export const AreaPickerModal: React.FC<AreaPickerModalProps> = ({ visible, onClose, onSelect, areas, selectedAreaId }) => {
  const { t } = useTranslation();
  const items: ListPickerItem[] = areas.map(toPickerItem);

  return (
    <ListPickerModal
      visible={visible}
      onClose={onClose}
      onSelect={item => onSelect(item)}
      title={t('address.selectArea')}
      items={items}
      selectedId={selectedAreaId}
      searchable
      searchPlaceholder={t('address.searchAreas')}
      emptyTitle={t('address.noAreasFound')}
      emptyText={t('address.noAreasHint')}
      renderItemLabel={getAreaLabel}
      itemIcon="map"
    />
  );
};

export default AreaPickerModal;
